<template>
  <div :class="$style.white" id="richText">
    <div v-html="data"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  props: ['data'],
  mounted () {
    // var audios = document.querySelectorAll('audio')
    // if (!audios.length) return
    // for (var i = 0; i < audios.length; i++) {
    //   var e = audios[i]
    //   e.addEventListener('play', function () {
    //     for (var j = 0; j < audios.length; j++) {
    //       if (i != j) {
    //         console.log(audios[j])
    //         audios[j].pause()
    //       }
    //     }
    //   })
    // }
    this.initATarget()
  },
  methods: {
    /**
     * 给图片添加 alt
     */
    initATarget () {
      let aTags = this.$el.querySelectorAll('a')

      aTags.forEach(a => {
        a.setAttribute('target', '_blank')
      })
    }
  }
}
</script>
<style lang="stylus" module>

// fork from http://git.geekbang.org/FE/time.geekbang.org/blob/f62ac841ec866a8802d35df195125591cef36ddf/src/assets/css/richContentCustomStyle/white.styl

$color-primary = #D7B375

$fontsize = 16px
$maincolor = #4A4A4A
$p_marginbottom = 20px
.white
  font-weight 400
  color $maincolor
  line-height 1.76
  white-space normal
  word-break normal
  font-size $fontsize
  // background #fff
  transition background-color .3s ease
  :global
    .MathJax_Display
      overflow auto
    .poster
      position fixed
      left -10000px
      top -10000px
      overflow hidden
      padding 1rem
      background #ECECEC

    .richcontent-pre-copy
      font-size 13px
      color #888
      position absolute
      right 1em
      top 0.6em
      cursor pointer
      user-select none

    .richcontent-pre-copy .iconfont
      font-size 12px
      margin-right 0.2em
    a
      color $color-primary
      border-bottom 1px solid $color-primary
    img
      display block
      max-width 100%
      position relative
      left 50%
      transform translateX(-50%)
      background-color #EEE
      vertical-align top
      border-radius 6px
    audio,
    video
      width 100%
      background-color #EEE
    pre
      margin-top 16px
      padding-left 0
      padding-right 0
      padding-top 30px
      padding-bottom 30px
      margin-bottom 30px
      position relative
      overflow hidden
      border-radius 6px
      background #F6F7FBBF
      border 0
    pre code
      font-size 12px
      font-family Consolas,"Liberation Mono",Menlo,monospace,Courier
      display block
      box-sizing border-box
      margin-left 16px
      margin-right 16px
      overflow-x auto
    hr
      border none
      margin-top 1.5rem
      margin-bottom 1.5rem
      border-top #F5F5F5 solid 1px
      height 1px
      background none
    h1,
    h2,
    h3,
    h4,
    h5
      margin-bottom 20px
      margin-top 0px
      font-weight bold
    b,
    strong
      font-weight bold
    for index in 1 2 3 4 5
      h{index}
        font-size $fontsize + (5 - index)
    p
      font-weight 400
      color $maincolor
      margin-top 0
      margin-bottom $p_marginbottom
      word-break break-word
      line-height 32px

    blockquote
      margin-top 0
      margin-bottom $p_marginbottom + 4
      border-left 3px solid #e8e8e8
      padding-left 17px
      color $maincolor
      p
        margin-top 0
        margin-bottom 0

    ol, ul
      margin-bottom $p_marginbottom
      p
        margin-top 0
        margin-bottom 0
    ol
      list-style decimal
      margin-left 20px
    ul
      li
        padding-left 17px
        position relative
        margin-bottom 10px
        &:after
          content ''
          height 6px
          width 6px
          border-radius 50%
          // background $maincolor
          background $color-primary
          position absolute
          top 10px
          left 0
    .orange
      // color $color-primary
      color $maincolor
      font-weight 500
    .reference
      // color #888
    table.hljs-ln
      box-sizing border-box
      margin-bottom 0
      border-spacing 0
      border-collapse collapse
    table.hljs-ln tbody
      box-sizing border-box
    table.hljs-ln tr
      box-sizing border-box
    table.hljs-ln td
      box-sizing border-box
      padding 0
      border 0
    table.hljs-ln td.hljs-ln-numbers
      min-width 15px
      font-family "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace
      font-size 12px
      line-height 20px
      color rgba(27,31,35,0.3)
      text-align right
      white-space nowrap
      vertical-align top
      cursor pointer
      user-select none
    table.hljs-ln td.hljs-ln-code
      position relative
      padding-right 10px
      padding-left 10px
      line-height 20px
      vertical-align top
      overflow visible
      font-family "SFMono-Regular",Consolas,"Liberation Mono",Menlo,Courier,monospace
      font-size 13px
      color #666666
      word-wrap normal
      white-space pre
.small
  font-size $fontsize - 2
  for index in 1 2 3 4 5
    h{index}
      font-size $fontsize - 2 + (5 - index)
  p
    margin-bottom $p_marginbottom - 4
  blockquote
    margin-bottom $p_marginbottom
  ol, ul
    margin-bottom $p_marginbottom - 4
.big
  font-size $fontsize + 2
  for index in 1 2 3 4 5
    h{index}
      font-size $fontsize + 2 + (5 - index)
</style>
